import { createFileRoute } from "@tanstack/react-router"
import Coaches from "@/app/settings/club/coaches/page"

export const Route = createFileRoute("/settings/club/coaches")({
  component: Coaches,
})
